module.exports = __webpack_public_path__ + "static/media/outbound-opt-in.ff79bc19.svg";